import Const from 'constants';

let ProjectedOwnershipCap = {
    setInnerProjectedOwnershipCapFromStorage(items) {
        return (dispatch) => {
            dispatch(this.setInnerProjectedOwnershipCap(items, {saveToStorage: false}));
        };
    },

    setInnerProjectedOwnershipCap(items, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.PROJECTED_OWNERSHIP_CAP_SET_INNER,
                    items,
                });

            saveToStorage && dispatch(
                this.saveDataToStorage('projectedOwnershipCap', function (state) {
                    const {projectedOwnershipCap} = state;
                    return {
                        innerCapBoundaries: projectedOwnershipCap.getInnerCapBoundaries(),
                    };
                }),
            );
        };
    },
};

export default ProjectedOwnershipCap;
